import { TYPES } from '../actionTypes';
//////////////////////////////////////////////
const { CURRENT_SESSION } = TYPES;
//////////////////////////////////////////////
export const userSession = (data) => ({
  type: CURRENT_SESSION,
  payload: data,
});
